import { takeEvery, put, select } from 'redux-saga/effects'
import { LOADING_CARETEAMS, receiveCareTeams, receiveCareTeam } from './actions'
import { PATIENT_RECEIVED } from '@medeo/patients'
import { getGroupMembers } from '../Group/ducks'
import { getAccessToken } from '@medeo/user'
import jwt from 'jsonwebtoken'

const URL = process.env.FHIR_URL

function* rootSaga() {
  yield takeEvery(LOADING_CARETEAMS, loadCareteams)
  yield takeEvery(PATIENT_RECEIVED, createCareteam)
}

function* loadCareteams(action) {
  const practitionerIdentifier = 'azeaze'
  const practitionerReference = '#pr1'
  // const practitioner = action.payload
  const response = yield fetch(URL + '/careteams', {
    methode: 'GET',
    header: {
      'Content-Type': 'application/json'
    }
  })
  const responseJSON = yield response.json()
  if (responseJSON.length > 0) {
    const careTeams = responseJSON.filter(careteam => {
      if (careteam.participant.length > 0) {
        let participants = careteam.participant.filter(
          participant =>
            participant.member.identifier === practitionerIdentifier ||
            participant.member.reference === practitionerReference
        )
        if (participants.length > 0) return true
      }
      return false
    })

    yield put(receiveCareTeams(careTeams))
  } else return []
}

function* createCareteam(action) {
  const patient = action.payload
  const accessToken = yield select(getAccessToken)
  const { fhirResourceId } = jwt.decode(accessToken, process.env.SECRET)
  const members = yield select(getGroupMembers)
  if (members.length > 1) {
    const adviserId = members.filter(
      member => member.entity.identifier !== fhirResourceId
    )[0]
    const careteamFhir = createCareteamFhir({
      adviserId,
      patientId: patient.id,
      practitionerId: fhirResourceId
    })

    const request = yield fetch(`${process.env.FHIR_URL}/careteams`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...(accessToken != null && { Authorization: `Bearer ${accessToken}` })
      },
      body: JSON.stringify(careteamFhir)
    })
    const careteam = yield request.json()
    yield put(receiveCareTeam(careteam))
  }
}

export default rootSaga

function createCareteamFhir(membersIds) {
  const { patientId, adviserId, practitionerId } = membersIds
  return {
    resourceType: 'CareTeam',
    status: 'active',
    category: [
      {
        coding: [
          {
            system: 'http://hl7.org/fhir/care-team-category',
            code: 'condition'
          }
        ]
      }
    ],
    subject: {
      reference: `Patient/${patientId}`,
      identifier: {
        value: patientId
      }
    },
    period: {
      start: new Date()
    },
    participant: [
      {
        role: {
          text: 'practitioner'
        },
        member: {
          reference: `Practitioner/${practitionerId}`,
          identifier: {
            value: practitionerId
          }
        }
      },
      {
        role: {
          text: 'adviser'
        },
        member: {
          reference: `Adviser/${adviserId}`,
          identifier: {
            value: adviserId
          }
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/Careteam/sagas.js